const segmentStyle = (previous, current, selectedRange) => {
  const selected = Boolean(
    selectedRange &&
    current.distanceM >= selectedRange.startM &&
    previous.distanceM <= selectedRange.endM
  )
  return { selected, type: current.type || 'acc' }
}

const groupMeasuredLineSegments = (coordinates, selectedRange = null) => {
  if (!Array.isArray(coordinates) || coordinates.length < 2) return []
  const groups = []

  for (let index = 1; index < coordinates.length; index += 1) {
    const previous = coordinates[index - 1]
    const current = coordinates[index]
    const style = segmentStyle(previous, current, selectedRange)
    const active = groups[groups.length - 1]
    if (active && active.selected === style.selected && active.type === style.type) {
      active.coordinates.push(current)
      active.pointIndex = current.pointIndex ?? index
    } else {
      groups.push({
        ...style,
        coordinates: [previous, current],
        pointIndex: current.pointIndex ?? index,
      })
    }
  }

  return groups
}

module.exports = { groupMeasuredLineSegments }
